import JsonDiff from "../Components/Utilities/JsonDiff/JsonDiff"
import Editor from "../Components/Utilities/Editor/Editor"
import Stopwatch from "../Components/Utilities/Stopwatch/Stopwatch";
import StringManipulation from "../Components/Utilities/StringManipulation/StringManipulation";
import RemoveDuplicate from "../Components/Utilities/RemoveDuplicate/RemoveDuplicate";
import TableGenerator from "../Components/Utilities/TableGenerator/TableGenerator";
import UuidGenerator from "../Components/Utilities/UuidGenerator/UuidGenerator";
import Escape from "../Components/Utilities/Escape/Escape";
import Converter from "../Components/Utilities/Converters/Converter/Converter";


const utilityPages = [
    {
        to: '',
        title: 'Utilities',
        children: [
            {
                to: '/json-diff',
                title: 'JSON diff',
                component: JsonDiff
            },
            {
                to: '/escape-unescape',
                title: 'Escape/Unescape',
                component: Escape
            },
            {
                to: '/duplicates',
                title: 'Duplicate Removal',
                component: RemoveDuplicate
            },
            {
                to: '/string',
                title: 'String Manipulation',
                component: StringManipulation
            },
            {
                to: '/table',
                title: 'Table Generator',
                component: TableGenerator
            },
            {
                to: '/uuid',
                title: 'UUID',
                component: UuidGenerator
            },
            {
                to: '/stopwatch',
                title: 'Stopwatch',
                component: Stopwatch
            }
        ]
    },
    {
        to: '/convert',
        title: 'Converter',
        component: Converter,
    },
    {
        to: '/editor',
        title: 'Editor',
        component: Editor,
    }
]

export default utilityPages